import { type ComponentType, createElement } from 'react'
import type { match, RouteProps } from 'react-router'
import { matchPath } from 'react-router'
import { Route, useLocation } from 'react-router-dom'
import UrlLocation from 'src/lib/url/UrlLocation'

const RouteWithComputedMatch = Route as ComponentType<RouteProps & {
  computedMatch?: match | null
}>

export default function LocaleAwareRoute(props: RouteProps) {
  const location = useLocation()
  const pathWithoutLocale = UrlLocation.fromLocation(location).withoutLocale().path
  const computedMatch = props.path ? matchPath(pathWithoutLocale, props) : undefined

  return createElement(RouteWithComputedMatch, {
    ...props,
    location,
    computedMatch,
  })
}
